/**
 * Lightweight conversion tracking helper.
 *
 * Pushes named conversion events to Google Analytics / Google Ads (gtag) and
 * to the Meta pixel (fbq) when either is present on the page. Safe no-op when
 * no tag manager is installed yet.
 */
export type ConversionEvent =
  | "phone_click"
  | "text_click"
  | "email_click"
  | "office_consultation_click"
  | "directions_click"
  | "lead_form_submit"
  | "photo_upload";

export const trackConversion = (
  event: ConversionEvent,
  params: Record<string, string | number> = {},
) => {
  if (typeof window === "undefined") return;
  const w = window as any;
  try {
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event, ...params });
    if (typeof w.gtag === "function") w.gtag("event", event, params);
    if (typeof w.fbq === "function") {
      const fbEvent = event === "lead_form_submit" ? "Lead" : "Contact";
      w.fbq("trackCustom", event, params);
      w.fbq("track", fbEvent, params);
    }
  } catch {
    /* tracking must never break the page */
  }
};
